import { MessageBox } from 'element-ui'

export function bytes(data, to) {
  const const_term = 1024
  if (to === 'KB') {
    return (data / const_term).toFixed(2) + 'KB'
  } else if (to === 'MB') {
    return (data / const_term ** 2).toFixed(2) + 'MB'
  } else if (to === 'GB') {
    return (data / const_term ** 3).toFixed(2) + 'GB'
  } else if (to === 'TB') {
    return (data / const_term ** 4).toFixed(2) + 'TB'
  }
}


export const TabIndex = {
  vault: 0,
  folder: 1,
  document: 2,
  permission: 3
}

export function copyCommand(value) {
  let transfer = document.createElement('input')
  document.body.appendChild(transfer)
  transfer.value = value  // 这里表示想要复制的内容
  transfer.focus()
  transfer.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  transfer.blur()
  document.body.removeChild(transfer)
}

export async function confirm(confirmText) {
  await MessageBox.confirm(confirmText, { confirmButtonText: 'Yes', cancelButtonText: 'Cancel' })
}
